import { PublicClientApplication } from '@azure/msal-browser';

export const msalConfig = {
  auth: {
    clientId:
      process.env.REACT_APP_MSAL_CLIENT_ID ||
      'd18faf6a-6313-41e3-ba63-3ed2e4d693a8',
    authority:
      process.env.REACT_APP_MSAL_AUTHORITY ||
      'https://login.microsoftonline.com/62a9c2c8-8b09-43be-a7fb-9a87875714a9',
    redirectUri:
      process.env.REACT_APP_MSAL_REDIRECT_URI ||
      `${window.location.origin}/admin/dashboard/`,
  },
  cache: {
    cacheLocation:
      process.env.REACT_APP_MSAL_CACHE_LOCATION || 'sessionStorage',
    storeAuthStateInCookie:
      process.env.REACT_APP_MSAL_STORE_AUTH_STATE_IN_COOKIE === 'true' || false,
  },
};

export const msalInstance = new PublicClientApplication(msalConfig);

// Ensure MSAL is initialized
msalInstance.initialize().catch((error) => {
  console.error('MSAL initialization failed', error);
});
